import styled from "styled-components";
import { PlainTextStyle } from "../../styled";

export const SectionHow = styled.section`
    padding-top: 100px;
    padding-bottom: 150px;
    z-index: 1000;
`;

export const HowContainer = styled.div`
    max-width: 1230px;
    margin-left: auto;
    margin-right: auto;
    padding-left: 25px;
    padding-right: 25px;
`;

export const HowTitle = styled.div`
    position: relative;
    z-index: 1;
    font-size: 60px;
    margin-bottom: 64px;
    font-weight: 700;
    @media (max-width: 1199px) {
        font-size: 60px;
        margin-bottom: 64px;
    }
    @media (max-width: 599px) {
        font-size: 50px;
        margin-bottom: 34px;
    }
`;

export const HowItWorksTextBlock = styled.div`
    flex-grow: 1;
    align-self: center;
`;

export const HowCards = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(3, 340px);
    grid-gap: 90px;
    width: 100%;
    z-index: 1;

    @media (max-width: 1199px) {
    }
`;

export const HowImageWrapper = styled.div`
    object-fit: contain;
    padding: 40px 40px 40px 40px;
`;

export const HowImage = styled.img`
    object-fit: contain;

    @media (max-width: 1199px) {
        //align-self: center;
        max-height: 60%;
        flex: 1 1 auto;
    }
`;

export const HowCard = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    flex-basis: 50%;
    gap: 20px;
    justify-content: space-evenly;

    &:nth-child(even) {
        flex-direction: row-reverse;
    }

    @media (min-width: 1199px) {
        height: 340px;
    }

    @media (max-width: 1199px) {
        flex-direction: column;
        justify-content: stretch;

        &:nth-child(even) {
            flex-direction: column;
        }
    }
`;

export const HowCardTitle = styled.h3`
    margin-bottom: 20px;
    font-size: 28px;
    font-weight: 700;
    line-height: 1;
    @media (max-width: 1199px) {
        font-size: calc(16px + (12) * ((100vw - 320px) / (1200 - 320)));
    }
`;

export const HowCardDescription = styled.div`
    ${PlainTextStyle}
    line-height: 1.4;
    font-weight: 300;
    align-self: center;
`;

export const Spacer = styled.span`
    width: 100px;
`;
